import { render, staticRenderFns, recyclableRender, components } from "./clerkorder.vue?vue&type=template&id=0d77e85e&scoped=true&"
var renderjs
import script from "./clerkorder.vue?vue&type=script&lang=js&"
export * from "./clerkorder.vue?vue&type=script&lang=js&"
import style0 from "./clerkorder.vue?vue&type=style&index=0&id=0d77e85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d77e85e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/store/part/clerkorder.vue"
export default component.exports